export enum Colors {
  white = '#ffffff',
  black = '#000000',
  lime = '#d6ff00',
}
